import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["numberInput", "submitButton", "form"]

  connect() {
    this.setBaselineValues()
    this.checkInputs()
  }

  setBaselineValues() {
    this.baselineValues = this.numberInputTargets.map(input => input.value)
  }

  checkInputs() {
    const allFilled = this.numberInputTargets.every(
      input => !isNaN(input.valueAsNumber)
    )

    const hasChanged = this.numberInputTargets.some(
      (input, index) => input.value !== this.baselineValues[index]
    )

    this.submitButtonTarget.disabled = !(allFilled && hasChanged)
  }

  submit() {
    console.log(this.submitButtonTarget.disabled)
    this.submitButtonTarget.disabled = true
    this.setBaselineValues()
  }

  showLoading() {
    const loadingScreen = document.getElementById("loading-screen")
    if (loadingScreen) loadingScreen.classList.remove("d-none")
  }
}
